/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Request_Field_ReasonInputs */

const en_cancel_request_field_reason = /** @type {(inputs: Cancel_Request_Field_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason for cancellation`)
};

const ja_cancel_request_field_reason = /** @type {(inputs: Cancel_Request_Field_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセルの理由`)
};

const fr_cancel_request_field_reason = /** @type {(inputs: Cancel_Request_Field_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motif de l'annulation`)
};

const de_cancel_request_field_reason = /** @type {(inputs: Cancel_Request_Field_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund für die Stornierung`)
};

/**
* | output |
* | --- |
* | "Reason for cancellation" |
*
* @param {Cancel_Request_Field_ReasonInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cancel_request_field_reason = /** @type {((inputs?: Cancel_Request_Field_ReasonInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Request_Field_ReasonInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancel_request_field_reason(inputs)
	if (locale === "ja") return ja_cancel_request_field_reason(inputs)
	if (locale === "fr") return fr_cancel_request_field_reason(inputs)
	return de_cancel_request_field_reason(inputs)
});